module.exports = __webpack_public_path__ + "static/media/Fajas.04d5ad00.png";